// extracted by mini-css-extract-plugin
export default {"page":"styles_page__j+TuM","wrapper":"styles_wrapper__4ih4P","canvas":"styles_canvas__tHIuo"};